// import React, { useEffect, useState } from "react";
// import { Bar, Pie } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   ArcElement,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import dataService from "../../networks/api/service/dataService";

// // Register Chart Elements
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   ArcElement,
//   Tooltip,
//   Legend
// );

// const VotersAreaGraph = ({ loading, data }) => {
//   if (loading) return <p style={styles.loading}>Loading...</p>;
//   if (!data) return <p style={styles.loading}>No data available</p>;

//   // Extracting data from the response
//   const voterDetails = data[2]?.voterDetails || {};

//   // Calculate total voters
//   const totalMale = voterDetails.totalMaleVoter || 0;
//   const totalFemale = voterDetails.totalFemaleVoter || 0;
//   const totalTransgender = voterDetails.totalTransgenderVoter || 0;
//   const totalVoters = totalMale + totalFemale + totalTransgender;

//   // Calculate percentages
//   const malePercentage = totalVoters
//     ? ((totalMale / totalVoters) * 100).toFixed(1)
//     : 0;
//   const femalePercentage = totalVoters
//     ? ((totalFemale / totalVoters) * 100).toFixed(1)
//     : 0;
//   const transgenderPercentage = totalVoters
//     ? ((totalTransgender / totalVoters) * 100).toFixed(1)
//     : 0;

//   // Dynamically building labels and data for the Bar Chart
//   const areaLabels = [];
//   const areaDataValues = [];

//   // Loop through all areas (booth, panchayat, etc.) and add them to the chart data
//   data.forEach((item) => {
//     if (item.booth && item.booth.totalNoOfBooth) {
//       areaLabels.push("Booth");
//       areaDataValues.push(item.booth.totalNoOfBooth);
//     }
//     if (item.panchayat && item.panchayat.totalNoOfPanchayat) {
//       areaLabels.push("Panchayat");
//       areaDataValues.push(item.panchayat.totalNoOfPanchayat);
//     }
//     if (item.assembly && item.assembly.totalNoOfAssembly) {
//       areaLabels.push("Assembly");
//       areaDataValues.push(item.assembly.totalNoOfAssembly);
//     }
//   });

//   // Bar Chart Data
//   const areaData = {
//     labels: areaLabels.length > 0 ? areaLabels : ["No Data"], // Fallback in case no data is available
//     datasets: [
//       {
//         label: "Area Distribution",
//         data: areaDataValues.length > 0 ? areaDataValues : [0], // Fallback in case no data is available
//         backgroundColor: [
//           "#4caf50",
//           "#ff9800",
//           "#2196f3",
//           "#3f51b5",
//           "#9c27b0",
//         ],
//       },
//     ],
//   };

//   // Pie Chart Data
//   const voterData = {
//     labels: [
//       `Male (${malePercentage}%)`,
//       `Female (${femalePercentage}%)`,
//       `Transgender (${transgenderPercentage}%)`,
//     ],
//     datasets: [
//       {
//         label: "Voters",
//         data: [totalMale, totalFemale, totalTransgender],
//         backgroundColor: ["#42a5f5", "#ef5350", "#ffca28"],
//       },
//     ],
//   };

//   return (
//     <div style={styles.container}>
//       {/* <div style={styles.voterCount}>
//         <span>Total Voters: </span>
//         <strong>{totalVoters.toLocaleString()}</strong>
//       </div> */}

//       <div style={styles.graphsContainer}>
//         <div style={styles.chartBox}>
//           <h3 style={styles.chartTitle}>Area Distribution</h3>
//           <div style={styles.chartWrapper}>
//             <Bar
//               data={areaData}
//               options={{ responsive: true, maintainAspectRatio: false }}
//             />
//           </div>
//         </div>

//         <div style={styles.chartBox}>
//           <h3 style={styles.chartTitle}>
//             <span>Total Voters: </span>
//             <strong>{totalVoters.toLocaleString()}</strong>
//           </h3>
//           <div style={styles.pieChartWrapper}>
//             <Pie
//               data={voterData}
//               options={{ responsive: true, maintainAspectRatio: false }}
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // 📏 **Updated Styling with Fixed Pie Chart Layout**
// const styles = {
//   container: {
//     width: "100%",
//     // minHeight: "100vh",
//     // padding: "20px",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     backgroundColor: "#f8f9fa",
//   },
//   voterCount: {
//     width: "90%",
//     // maxWidth: "800px",
//     backgroundColor: "#3f51b5",
//     color: "#fff",
//     padding: "12px",
//     textAlign: "center",
//     borderRadius: "6px",
//     fontSize: "18px",
//     fontWeight: "bold",
//     marginBottom: "15px",
//   },
//   graphsContainer: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//     gap: "20px",
//     width: "95%",
//     maxWidth: "100%",
//     justifyContent: "center",
//   },
//   chartBox: {
//     width: "100%",
//     backgroundColor: "#fff",
//     padding: "15px",
//     borderRadius: "8px",
//     boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
//     textAlign: "center",
//   },
//   chartTitle: {
//     marginBottom: "10px",
//     color: "#333",
//     fontSize: "16px",
//     fontWeight: "bold",
//   },
//   chartWrapper: {
//     height: "300px",
//   },
//   pieChartWrapper: {
//     height: "280px", // **Fixed Pie Chart Overflow**
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "10px",
//   },
//   loading: {
//     fontSize: "16px",
//     color: "#666",
//     textAlign: "center",
//     marginTop: "40px",
//   },
// };

// export default VotersAreaGraph;

import React, { useEffect, useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { message } from "antd";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend
);

const AllLevelBriefDetails = ({ loading, data }) => {
  if (loading) return <p style={styles.loading}>Loading...</p>;
  if (!data) return <p style={styles.loading}>No data available</p>;
  const voterDetails = data.find(item => item.voterDetails)?.voterDetails || {};
  const totalMale = voterDetails.totalMaleVoter || 0;
  const totalFemale = voterDetails.totalFemaleVoter || 0;
  const totalTransgender = voterDetails.totalTransgenderVoter || 0;
  const totalVoters = totalMale + totalFemale + totalTransgender;
  
  const malePercentage = totalVoters
    ? ((totalMale / totalVoters) * 100).toFixed(1)
    : 0;
  const femalePercentage = totalVoters
    ? ((totalFemale / totalVoters) * 100).toFixed(1)
    : 0;
  const transgenderPercentage = totalVoters
    ? ((totalTransgender / totalVoters) * 100).toFixed(1)
    : 0;
    
    console.log("Full Data Array:", data);
    console.log("Data[2] Object:", data[2]);

    console.log("VoterDetails Object:", voterDetails);
   console.log("Male :",totalMale);
   console.log("Female :",totalFemale);
   console.log("Transgender :",totalTransgender);

  const areaLabels = [];
  const areaDataValues = [];

  data.forEach((item) => {
   //console.log("Item =",item);
    if (item.block && item.block.totalBlock) {
      areaLabels.push("Block");
      areaDataValues.push(item.block.totalBlock);
    }
    //console.log(item?.UrbanMNAC?.totalUrbanMNAC,"item.urbanMNAC.totalUrbanMNAC")
    if (item.UrbanMNAC && item.UrbanMNAC.totalUrbanMNAC) {
     // message.success("pushed");
      areaLabels.push("Urban(M/NAC)");
      areaDataValues.push(item.UrbanMNAC.totalUrbanMNAC);

    }
    if (item.urbanWard && item.urbanWard.totalurbanWard) {
      areaLabels.push("Urban(Ward)");
      areaDataValues.push(item.urbanWard.totalurbanWard);
    }
    if (item.panchayat && item.panchayat.totalNoOfPanchayat) {
      areaLabels.push("Gram Panchayat");
      areaDataValues.push(item.panchayat.totalNoOfPanchayat);
    }
    if (item.booth && item.booth.totalNoOfBooth) {
      areaLabels.push("Booth");
      areaDataValues.push(item.booth.totalNoOfBooth);
    }
    if (item.village && item.village.totalVillage) {
      areaLabels.push("Village");
      areaDataValues.push(item.village.totalVillage);
    }
    
 
  });

  const areaData = {
    labels: areaLabels.length > 0 ? areaLabels : ["No Data"],
    datasets: [
      {
        label: "Area Distribution",
        data: areaDataValues.length > 0 ? areaDataValues : [0],
        backgroundColor: [
          "#4caf50",
          "#ff9800",
          "#2196f3",
          "#3f51b5",
          "#9c27b0",
        ],
      },
    ],
  };
  const voterData = {
    labels: [
      `Male (${malePercentage}%)`,
      `Female (${femalePercentage}%)`,
      `Transgender (${transgenderPercentage}%)`,
    ],
    datasets: [
      {
        label: "Voters",
        data: [totalMale, totalFemale, totalTransgender],
        backgroundColor: ["#42a5f5", "#ef5350", "#ffca28"],
      },
    ],
  };

  console.log("Voter data:",voterData);

  return (
    <div style={styles.container}>
      <div style={styles.graphsContainer}>
        <div style={styles.chartBox}>
          <h3 style={styles.chartTitle}>Area Distribution</h3>
          <div style={styles.chartWrapper}>
            <Bar
              data={areaData}
              options={{ responsive: true, maintainAspectRatio: false }}
            />
          </div>
        </div>

        <div style={styles.chartBox}>
          <h3 style={styles.chartTitle}>
            <span>Total Voters: </span>
            <strong>{totalVoters.toLocaleString()}</strong>
          </h3>
          <div style={styles.pieChartWrapper}>
            <Pie
              data={voterData}
              options={{ responsive: true, maintainAspectRatio: false }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#f8f9fa",
  },
  graphsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "20px",
    width: "95%",
    maxWidth: "100%",
    justifyContent: "center",
  },
  chartBox: {
    width: "100%",
    backgroundColor: "#fff",
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
  },
  chartTitle: {
    marginBottom: "10px",
    color: "#333",
    fontSize: "16px",
    fontWeight: "bold",
  },
  chartWrapper: {
    height: "300px",
  },
  pieChartWrapper: {
    height: "280px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px",
  },
  loading: {
    fontSize: "16px",
    color: "#666",
    textAlign: "center",
    marginTop: "40px",
  },
};

export default AllLevelBriefDetails;
